'use client';
import { useParams } from 'next/navigation';
import { defaultLang, SUPPORTED } from "../../config/languages";
import { getStaticPageSeo } from "../../lib/staticPageSeo";
import PageLayout from "../PageLayout";
import PrivacyPolicyText from "./text";
import PrivacyPolicyTextSr from "./text.sr";

const PrivacyPolicy = () => {
  const { lang = defaultLang, slug } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;
  const seo = getStaticPageSeo('privacy-policy', activeLang);

  return (
    <PageLayout 
      showWorkspaceCta
      title={seo.title}
      metaDescription={seo.description}
      canonical={`https://www.adcast.app${activeLang === 'en' ? '' : '/' + activeLang}/privacy-policy`} 
      ogType="article"
    >
        {activeLang === 'sr' ? <PrivacyPolicyTextSr /> : <PrivacyPolicyText />}
    </PageLayout>
  );
}

export default PrivacyPolicy;
